import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=46a340ac&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=js&"
export * from "./IconCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a340ac",
  null
  
)

export default component.exports